module.exports = __webpack_public_path__ + "static/media/rank_predictor.47f9cd82.png";